import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { SuccessResponse } from '../../../model/success-response.model';
import { UpdateProfileInfoPayload } from '../state/settings.state';

@Injectable({
  providedIn: 'root',
})
export class SettingsService {
  private apiServerHost: string = environment.apiServerHost;

  constructor(private httpClient: HttpClient) {}

  updateProfileInfo(
    userId: number,
    payload: UpdateProfileInfoPayload,
  ): Observable<SuccessResponse> {
    return this.httpClient.post<SuccessResponse>(
      `${this.apiServerHost}/cm-services/api/v1/account-service/users/${userId}/update-profile-info`,
      payload,
    );
  }

  sendDeleteVerificationCode(
    userId: number,
    emailId: string,
  ): Observable<SuccessResponse> {
    return this.httpClient.post<SuccessResponse>(
      `${this.apiServerHost}/cm-services/api/v1/login-service/verification-code/request-otp`,
      {
        userId,
        emailId,
        purpose: 'DELETE_ACCOUNT',
      },
    );
  }

  deleteAccount(
    userId: number,
    emailId: string,
    verificationCode: string,
  ): Observable<SuccessResponse> {
    return this.httpClient.post<SuccessResponse>(
      `${this.apiServerHost}/cm-services/api/v1/login-service/users/${userId}/delete-account`,
      { emailId, verificationCode },
      { withCredentials: true },
    );
  }
}
